// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OrchMedicalCardFinderTransactionSearchResponseModelRequest } from './orchMedicalCardFinderTransactionSearchResponseModelRequest.js';
import type { OrchMedicalCardFinderTransactionSearchResponseModelResult } from './orchMedicalCardFinderTransactionSearchResponseModelResult.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class OrchMedicalCardFinderTransactionSearchResponseModel {
    'request'?: OrchMedicalCardFinderTransactionSearchResponseModelRequest | null;
    'result'?: OrchMedicalCardFinderTransactionSearchResponseModelResult | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof OrchMedicalCardFinderTransactionSearchResponseModel>> = [
        {
            "name":     "request",
            "baseName": "request",
            "type":     "OrchMedicalCardFinderTransactionSearchResponseModelRequest"
        },
        {
            "name":     "result",
            "baseName": "result",
            "type":     "OrchMedicalCardFinderTransactionSearchResponseModelResult"
        },
    ];

    static getAttributeTypeMap() {
        return OrchMedicalCardFinderTransactionSearchResponseModel.attributeTypeMap;
    }
}
